import "../../assets/index5.css";
import { jsx as f } from "react/jsx-runtime";
import { m as c } from "../../chunks/make-refs.cb0b9b76.js";
import { forwardRef as i } from "react";
import { c as _ } from "../../chunks/index.80e735c1.js";
const g = "_tag_1f4zh_1", h = "_danger_1f4zh_21", m = "_decaffeinato_1f4zh_26", l = "_highlight_1f4zh_30", d = "_informative_1f4zh_34", u = "_success_1f4zh_39", z = "_warning_1f4zh_44", e = {
  tag: g,
  danger: h,
  decaffeinato: m,
  highlight: l,
  informative: d,
  success: u,
  warning: z
}, p = ({ className: s, variant: t }) => _(e.tag, s, {
  [e[t]]: t !== "default"
}), $ = i(
  ({ className: s, label: t, variant: a = "default", ...n }, o) => {
    const { $el: r } = c(o, ["$el"]);
    return /* @__PURE__ */ f("mark", { ref: r, className: p({ className: s, variant: a }), ...n, children: t });
  }
);
export {
  $ as Tag
};
//# sourceMappingURL=index.js.map
